import { Button, Menu, MenuItem, ListItemText } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useId, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ManageMenuItem } from "@utils/getSubscriptionDisplayInformation";

interface SubscriptionManageMenuProps {
  menuItems: ManageMenuItem[];
}

const SubscriptionManageMenu = ({ menuItems }: SubscriptionManageMenuProps) => {
  const { t } = useTranslation();
  const uid = useId();
  const buttonId = `manage-button-${uid}`;
  const menuId = `manage-menu-${uid}`;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  if (menuItems.length === 0) return null;

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleMenuItemClick = (item: ManageMenuItem) => async () => {
    handleClose();
    try {
      await item.action?.();
    } catch (error) {
      console.error("Manage menu action failed:", error);
    }
  };

  return (
    <div className="flex flex-col">
      <Button
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : "false"}
        variant="text"
        size="small"
        color="primary"
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        onClick={handleOpen}
        className="p-0 min-w-[100px]"
      >
        {t("Manage")}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": buttonId }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {menuItems.map((item) => {
          const label = (
            <ListItemText
              primaryTypographyProps={{
                className: item.destructive ? "text-error-main" : "text-text-primary"
              }}
            >
              {t(item.label)}
            </ListItemText>
          );

          if (item.route) {
            return (
              <MenuItem
                key={item.label}
                component={RouterLink}
                to={item.route}
                onClick={handleMenuItemClick(item)}
              >
                {label}
              </MenuItem>
            );
          }

          return (
            <MenuItem
              key={item.label}
              onClick={handleMenuItemClick(item)}
            >
              {label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default SubscriptionManageMenu;
